module.exports = __webpack_public_path__ + "img/c1.78ca5e26.png";